import type { ReactNode } from 'react';
import { Button } from 'react-aria-components';
import { useIntl } from 'react-intl';
import cx from 'clsx';
import styles from '../attachment.module.css';

interface TitleProps {
  children: ReactNode;
  onPreview?: () => void;
}

export function Title({ children, onPreview }: TitleProps) {
  const { formatMessage } = useIntl();

  if (onPreview) {
    return (
      <Button
        aria-label={formatMessage({ id: 'a11y-buttons-open-file-aria-label' })}
        className={cx('body-standard', styles.previewText)}
        data-testid="title"
        onPress={onPreview}
        type="button"
      >
        {children}
      </Button>
    );
  }

  if (typeof children === 'string') {
    return (
      <p className={cx('body-standard', styles.title)} data-testid="title">
        {children}
      </p>
    );
  }

  return children;
}
